import { Inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '@ridango/core';
import { TranslateService } from '@ngx-translate/core';
import Env from '@ridango/core/env';

@Injectable()
export class UnauthGuard implements CanActivate {
    constructor(
        @Inject('ENV') private env: Env,
        private authService: AuthService,
        private router: Router,
        private translate: TranslateService
    ) {}
    canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot) {
        if (this.env.SIGN_ON_PAGE) {
            return true;
        }
        if (this.authService.getLoginStatus()) {
            this.router.navigate([this.translate.currentLang, 'account']);
        }
        return !this.authService.getLoginStatus();
    }
}
